import {ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';

import {routes} from './app.routes';
import {errorInterceptor} from '@core/interceptors/error.interceptor';
import {AppInitService} from '@services/app-init.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([errorInterceptor])
    ),

    provideAppInitializer(() => {
      const appInitService = inject(AppInitService);
      return appInitService.initAsPromise();
    }),
  ],
};
